module.exports = __webpack_public_path__ + "img/collaboration1.d1a20a11.png";